import { createFileRoute, redirect } from '@tanstack/react-router';

import { getUserSession } from '@/server/user';

export const Route = createFileRoute('/_public')({
  staticData: {
    public: true,
  },
  beforeLoad: async () => {
    const { authentication } = await getUserSession();
    if (authentication?.accessToken) {
      throw redirect({ to: '/', replace: true });
    }
  },
});
